// @flow

import React from 'react';

import {
  InfiniteListFetcher,
  type InfiniteListFetcherProps,
} from 'app/general/datafetchers/InfiniteListFetcher';
import {
  buildMultipleDataFetcher,
  buildSingleDataFetcher,
} from 'app/general/datafetchers/builders';
import {convertLocationParamsToFetchParams} from 'app/store/sweet-api/utils';
import {getDenormalizedListFactory} from 'app/utils/redux_v2';

import {
  fetchDocumentSignoffList,
  fetchSignoffList,
  fetchSignoffTemplateList,
  fetchGroupedSignoffList,
} from './actions';
import type {
  DocumentSignoffType,
  SignoffType,
  SignoffTemplateType,
  GroupedSignoffType,
} from './types';

/* signoffs */

const denormalizeSignoffList = getDenormalizedListFactory<SignoffType>(
  (state) => state.signoffs.get('signoffs')
);

export const MultipleStoredSignoffFetcher =
  buildMultipleDataFetcher<SignoffType>(
    convertLocationParamsToFetchParams,
    // $FlowFixMe - flow doesn't understand redux-thunk magic
    fetchSignoffList,
    denormalizeSignoffList
  );

export const StoredSignoffFetcher = buildSingleDataFetcher<SignoffType>(
  MultipleStoredSignoffFetcher
);

/* doc signoffs */

const denormalizeDocumentSignoffList =
  getDenormalizedListFactory<DocumentSignoffType>((state) =>
    state.signoffs.get('documentsignoffs')
  );

export const MultipleStoredDocumentSignoffFetcher =
  buildMultipleDataFetcher<DocumentSignoffType>(
    convertLocationParamsToFetchParams,
    // $FlowFixMe - flow doesn't understand redux-thunk magic
    fetchDocumentSignoffList,
    denormalizeDocumentSignoffList
  );

export const StoredDocumentSignoffFetcher =
  buildSingleDataFetcher<DocumentSignoffType>(
    MultipleStoredDocumentSignoffFetcher
  );

export const DocumentSignoffInfiniteListFetcher = (
  props: InfiniteListFetcherProps<DocumentSignoffType>
) => (
  <InfiniteListFetcher
    DataFetcher={MultipleStoredDocumentSignoffFetcher}
    {...props}
  />
);

export const SignoffInfiniteListFetcher = (
  props: InfiniteListFetcherProps<SignoffType>
) => (
  <InfiniteListFetcher DataFetcher={MultipleStoredSignoffFetcher} {...props} />
);

/* signofftemplates */

const denormalizeSignoffTemplateList =
  getDenormalizedListFactory<SignoffTemplateType>((state) =>
    state.signoffs.get('signofftemplates')
  );

export const MultipleStoredSignoffTemplateFetcher =
  buildMultipleDataFetcher<SignoffTemplateType>(
    convertLocationParamsToFetchParams,
    // $FlowFixMe - flow doesn't understand redux-thunk magic
    fetchSignoffTemplateList,
    denormalizeSignoffTemplateList
  );

export const StoredSignoffTemplateFetcher =
  buildSingleDataFetcher<SignoffTemplateType>(
    MultipleStoredSignoffTemplateFetcher
  );

export const SignoffTemplateInfiniteListFetcher = (
  props: InfiniteListFetcherProps<SignoffTemplateType>
) => (
  <InfiniteListFetcher
    DataFetcher={MultipleStoredSignoffTemplateFetcher}
    {...props}
  />
);

/* grouped signoffs */

const denormalizeGroupedSignoffList =
  getDenormalizedListFactory<GroupedSignoffType>((state) =>
    state.signoffs.get('groupedSignoffs')
  );

export const MultipleStoredGroupedSignoffFetcher =
  buildMultipleDataFetcher<GroupedSignoffType>(
    convertLocationParamsToFetchParams,
    // $FlowFixMe - flow doesn't understand redux-thunk magic
    fetchGroupedSignoffList,
    denormalizeGroupedSignoffList
  );

export const StoredGroupedSignoffFetcher =
  buildSingleDataFetcher<GroupedSignoffType>(
    MultipleStoredGroupedSignoffFetcher
  );

// export const GroupedSignoffInfiniteListFetcher = (props: InfiniteListFetcherProps<GroupedSignoffType>) => (
//     <InfiniteListFetcher
//         DataFetcher={MultipleStoredGroupedSignoffFetcher}
//         {...props}
//     />
// );
